import { http } from './http'

export function getChildren () {
  return http.get('/api/dict/children')
}

export function createChild (payload) {
  return http.post('/api/dict/children', payload)
}

export function updateChild (id, payload) {
  return http.put(`/api/dict/children/${id}`, payload)
}

export function setChildActive (id, active) {
  return http.put(`/api/dict/children/${id}/active`, { active })
}

export function setChildTags (id, tag_ids) {
  return http.put(`/api/dict/children/${id}/tags`, { tag_ids })
}
